import api from './api';

export async function getRedeemGiftCardsDetailsAPI(companyId: string | undefined) {
  return api.get(`/api/dashboard/companies/${companyId}/giftcards/redeems`).then((response) => response.data);
}
